const itinerary = require('./itinerary_prototype');
const segment = require('./segment');
const passengers = require('./passengers');

function mytripsItinerary(itineraryData) {
    const mytripsItinerary = Object.create(itinerary(itineraryData));
    const segmentsArray = Odigeo._.get(itineraryData, 'itineraryBookings.itinerarySegments');
    const travellersData = Odigeo._.get(itineraryData, 'travellers');

    mytripsItinerary._segments = Odigeo._.map(segmentsArray, (segmentData) => {
        return segment(segmentData);
    });

    mytripsItinerary._passengers = passengers(Odigeo._.groupBy(travellersData, 'travellerType'));

    return mytripsItinerary;
}

module.exports = mytripsItinerary;
